import { Grid, Stack } from '@mantine/core';
import { FlexibleSkeleton } from '@/_legacy-mantine/components/FlexibleSkeleton/index.ts';

function PeopleDetailsViewSkeleton() {
  return (
    <Stack gap="md">
      <Grid>
        {Array(5)
          .fill('peopleSkeletonItems')
          .map((item, index) => (
            <Grid.Col span={6} key={item + index}>
              <FlexibleSkeleton
                direction="column"
                gap="md"
                customItems={[
                  {
                    height: 20,
                    width: '50%',
                  },
                  {
                    height: 20,
                    width: '75%',
                  },
                ]}
              />
            </Grid.Col>
          ))}
      </Grid>
    </Stack>
  );
}

export default PeopleDetailsViewSkeleton;
